import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from "@sentry/angular";
import { BrowserTracing } from "@sentry/tracing";

if (environment.production) {
  enableProdMode();

  Sentry.init({
    dsn: environment.sentry_key,
    integrations: [
      new BrowserTracing({
        tracingOrigins: ["https://dev-benefits.acessorh.com.br", "https://dev-admin.acessorh.com.br/svc2'", "https://dev-admin.acessorh.com.br/api/benefits/v1", "https://admin.acessorh.com.br/svc2", "https://admin.acessorh.com.br/api/benefits/v1", "https://benefits.acessorh.com.br"],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],
    tracesSampleRate: 0.01,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
